import './index.css';
import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import abackground from './components/Background.mp4';
const Home = lazy(() => import("./pages/Home.js"));
const NoFound = lazy(() => import("./pages/NoFound.js"));
const Wiki = lazy(() => import("./pages/Wiki/Wiki.js"));
const Suport = lazy(() => import("./pages/support.js"));

document.addEventListener('contextmenu', function (e) {
  e.preventDefault();
});

function App() {
  return (
      <div className="App">
        <link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap" rel="stylesheet" />
        <link href="https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap" rel="stylesheet" />
        <div className="abackground">
            <video autoPlay loop muted playsInline>
                <source src={abackground} type="video/mp4"/>
                Failed
            </video>
        </div>

        <Suspense>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="*" element={<NoFound />} />
            <Route path='/wiki/*' element={<Wiki />} />
            <Route path='/support' element={<Suport />} />
          </Routes>
        </Suspense>
      </div>
  );
}

export default App;
